<style scoped> 
    .label {
        font-weight: 600;
    }
</style>

<template>
    <div :class="['mb-4', divGridClass]">
		<div class="form-group mb-2 mb-md-0">
			<label class="label" for="pd_note">{{label}}</label>
			<textarea
                :placeholder="'Enter ' + label"
				class="form-control"
				v-model="selected"
				rows="2"
                :disabled="is_view"
			>
			</textarea>
		</div>
	</div>
</template>
  
<script>
export default {
    name: 'AdditionalInfo',
    props: {
        divGridClass : {
            type : String,
            default : 'col-md-8',
        },
        label : {
            type : String,
            default : '',
        },
        value: {
            type: [String, Number, Object],
            default: null
        },
        is_view : {
            type : Boolean,
            default : false
        }
    },
    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    }
}
</script>